import { ViewTabs } from "./ViewTabs";

export default ViewTabs;
